import {NavAvatar} from "../../nav/NavAvatar";

declare var $:any;

import {createRef} from "react";
import * as React from 'react';
import { VoidFunc } from 'types/types';
import {computed, observable} from 'mobx';
import { observer } from 'mobx-react';

import './Modal.pcss';
import FullPostModalData from "../../../data/FullPostModalData";
import {UIState} from "../../../data/UIState";

interface Props {
	title:string;
	subTitle?:string;
	user?:any;
	closeModal:VoidFunc;
}

@observer
export class Modal extends React.Component<Props> {
	@observable browserHeight:number = 0;
	titleRef;

	constructor(props:Props) {
		super(props);
		this.updateDimensions();
		this.titleRef = createRef()
	}

	updateDimensions = () => {
    this.browserHeight = $(window).height();
	}
	
  componentDidMount(){
    window.addEventListener("resize", this.updateDimensions);
		if(this.titleRef && this.titleRef.current) {
			this.titleRef.current.focus();
		}
	}
	
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
	}

	@computed get subTitle() {
		if(UIState.isMobile) {
			return null;
		} else {
			if(this.props.subTitle) {
				return <h2>{this.props.subTitle}</h2>;
			} else if(this.props.user) {
				return (
						<h2>
							<span className="material-icons verified" aria-hidden="true">verified</span>
							<span className="name">{this.props.user.firstName} {this.props.user.lastName}</span>
							{FullPostModalData.author.professionalTitle && <span>&nbsp;•&nbsp;{FullPostModalData.author.professionalTitle}</span>}
						</h2>
				)
			} else {
				return null;
			}
	}

	}
	
	render() {
		return (
			<>
				<div className="dim"></div>
				<div className="page modal" style={{height:this.browserHeight}}>
					<div className="modal-header">
						<div className="mh-left">
							<a href="#" onClick={this.props.closeModal} role={'button'} tabIndex={0}>
								<span className="material-icons" aria-hidden="true">arrow_back_ios_new</span>
								<span className="visuallyhidden">Back</span>
							</a>
						</div>
						<div className="mh-middle">
							{(!UIState.isMobile && this.props.user) && <div className="mh-avatar"><NavAvatar user={this.props.user} variant={'boxy'} /></div>}
							<div className={`mh-title${this.props.subTitle?'':' no-subtitle'}`}>
								<h1 ref={this.titleRef} tabIndex={0}>{this.props.title}</h1>
								{this.subTitle}
							</div>
						</div>
						<div className="right"></div>
					</div>
					<div className="body scroll">
						{this.props.children}
					</div>
				</div>
			</>
		);
	}
}




